import { useQuery } from '@apollo/client';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import { ReportEntityType } from 'components/ReportsModule/types';
import { baseWhere } from 'graph/apollo-util';
import GET_ACTIVE_STUDENTS_REPORT from 'graph/reports/get-active-students-report';

import { PrmActiveStudentsReportResult } from 'types/schema-generated-types';

const useActiveStudentReport = () => {
  const [{ entityId, entityType }] = useReportQueryParams();

  const inputMap = {
    [ReportEntityType.CLASSROOM]: { classroomId: entityId },
    [ReportEntityType.DISTRICT]: { organizationId: entityId },
    [ReportEntityType.SCHOOL]: { organizationId: entityId },
    [ReportEntityType.USER_GROUP]: { organizationId: entityId },
    [ReportEntityType.STUDENT]: { classroomId: entityId },
    [ReportEntityType.USER]: { userId: entityId } //educator
  };
  const activeStudentsReportInput = baseWhere(inputMap[entityType]);

  const { data: activeStudentsReportData, loading } = useQuery<{
    prmActiveStudentsReport: PrmActiveStudentsReportResult;
  }>(GET_ACTIVE_STUDENTS_REPORT, activeStudentsReportInput);
  return [
    {
      activeStudentsReportData,
      loading
    }
  ];
};

export default useActiveStudentReport;
